import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import FloatingMenuButton from './FloatingMenuButton';

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen bg-gray-50 relative overflow-hidden">
      {/* Sidebar */}
      <Sidebar 
        isOpen={sidebarOpen} 
        onClose={() => setSidebarOpen(false)} 
      />
      
      {/* Main Content Area */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-50 p-6">
          <div className="max-w-7xl mx-auto">
            {children}
          </div>
        </main>
      </div>

      {/* Floating Menu Button - Always visible */}
      <FloatingMenuButton 
        onClick={() => setSidebarOpen(!sidebarOpen)} 
        isOpen={sidebarOpen} 
      />
    </div>
  );
};

export default Layout;